module.exports = __webpack_public_path__ + "img/06.be635c5f.jpg";